import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { InvoiceListItem, InvoiceDetail } from '@/types'

interface InvoicesResponse {
  data: InvoiceListItem[]
  meta: { total_count: number; current_page: number; total_pages: number }
}

export function useInvoices() {
  return useQuery({
    queryKey: ['customer', 'invoices'],
    queryFn: async () => {
      const response = await api.get<InvoicesResponse>('/api/customer/invoices')
      return response.data
    },
  })
}

export function useInvoice(id: number) {
  return useQuery({
    queryKey: ['customer', 'invoices', id],
    queryFn: async () => {
      const response = await api.get<{ data: InvoiceDetail }>(`/api/customer/invoices/${id}`)
      return response.data.data
    },
    enabled: !!id,
  })
}
